/** 
 * @type {ProjectRatingsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    project_ids: null,
}
/** 
* @returns {ProjectRatingsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ProjectRatingsFilter.js